// Import themes.
import { Classic_Theme } from '../theme/classic';
import { Shape_Theme } from '../theme/shape';

/**
 * FAB Link
 * @class FABLink
 * @static
 * @method is_single_type
 * @method get_class
 * @method get_styles_object
 * @method get_styles
 * @method get_responsive_class
 * @method handle_click_analytics
 */
export default class FABLink {
  /**
   * is Single Type
   * - TODO: Still unclear about why we're implementing this.
   *
   * @param {Object} item
   * @returns {Boolean}
   */
  static is_single_type(item) {
    return item.classNames.includes('fab-single-collection') ? true : false;
  }

  /**
   * Get class
   * @param {Object} item
   * @returns {String}
   */
  static get_class(item) {
    let { fab_design } = window.FAB_PLUGIN.options;

    // Initialize class names.
    let classNames = 'fab-links fab-link-container flex items-center place-content-center min-w-max cursor-pointer ';

    // Add default classname from parent component.
    classNames += item.classNames ? `${item.classNames} ` : '';

    // Add classname for link type.
    classNames += `fab-link-type-${item.type} `;

    // Add responsive class.
    classNames += FABLink.get_responsive_class(item);

    // TEMPLATE: Add classname for classic template.
    if (!FABLink.is_single_type(item) && fab_design.template.name === 'classic') {
      classNames += 'bg-white rounded-full border border-slate-100 shadow-md ';
    }

    return classNames;
  }

  /**
   * Get styles object
   * - Styles object is used to control the styles of the fab link component.
   * @param {Object} item
   * @returns {Object}
   */
  static get_styles_object(item) {
    let { fab_design } = window.FAB_PLUGIN.options;

    // Initialize styles object.
    let styles = {
      singleType: FABLink.is_single_type(item),
      button: {
        color: item.template?.color || fab_design.template.color,
      },
      icon: {
        color: item.template?.icon?.color || fab_design.template.icon.color,
      },
      tooltip: {
        label: fab_design.tooltip.enable && item.title,
        color: item.tooltip?.color || fab_design.template.color,
        font: {
          color: item.tooltip?.font?.color || fab_design.template.icon.color,
        },
      },
    };

    // Theme: Set styles by theme.
    if (fab_design.template.name === 'classic') {
      styles = Classic_Theme.get_styles_object(styles);
    } else if (fab_design.template.name === 'shape') {
      styles = Shape_Theme.get_styles_object(styles);
    }

    return styles;
  }

  /**
   * Get styles
   * @param {Object} item
   * @param {Boolean} tooltipDisplay
   * @returns {Object}
   */
  static get_styles(item, tooltipDisplay) {
    let { to_display, options } = window.FAB_PLUGIN;
    let { fab_design } = options;
    let styles = '';

    // TEMPLATE: Set width to min-content if it's not a single type and the template is classic.
    if (
      (!FABLink.is_single_type(item) || to_display.length === 1) &&
      fab_design.template.name !== 'shape' &&
      tooltipDisplay
    ) {
      styles += `width:min-content;`;
    }

    // Padding.
    styles += `padding: ${fab_design.font.padding.top}${fab_design.font.padding.sizing} `;
    styles += `${fab_design.font.padding.right}${fab_design.font.padding.sizing} `;
    styles += `${fab_design.font.padding.bottom}${fab_design.font.padding.sizing} `;
    styles += `${fab_design.font.padding.left}${fab_design.font.padding.sizing};`;

    // Return styles.
    return styles;
  }

  /**
   * Get responsive class
   * @param {Object} item
   * @returns {String}
   */
  static get_responsive_class(item) {
    let responsiveClass = '';
    responsiveClass += item.responsive.device.mobile ? 'flex ' : 'hidden ';
    responsiveClass += item.responsive.device.tablet ? 'sm:flex ' : 'sm:hidden ';
    responsiveClass += item.responsive.device.desktop ? 'lg:flex ' : 'lg:hidden ';
    return responsiveClass;
  }

  /**
   * Register On Click Event
   * - This is required for third party plugins to trigger the modal.
   *
   * @param {Object} fab - FAB Item
   * @return void
   * */
  static register_on_click_event(fab) {
    jQuery(`#fab-link-${fab.ID}`).on('click', function () {
      window.dispatchEvent(
        new CustomEvent(`fab-link-${fab.ID}`, {
          detail: {
            fab_item: fab,
          },
        })
      );
    });
  }

  /**
   * Handle click analytics
   * @param {Object} item
   * @returns {Void}
   */
  static handle_click_analytics(item) {
    const { rest_url } = window.FAB_PLUGIN;

    // Prevent default click behavior
    event.preventDefault();

    // Get href and target.
    const href = item.linkHref ? item.link : null;
    const target = item.linkBehavior === 'yes' ? '_blank' : null;

    // Send analytics to server.
    fetch(rest_url + 'fab/v1/clicked', {
      method: 'POST',
      headers: {
        'X-WP-Nonce': window.FAB_PLUGIN.nonce.clicked,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        post_id: item.ID,
      }),
    })
      .then(() => {
        // After successful request, handle redirect if href exists
        if (href) {
          if (target === '_blank') {
            window.open(href, '_blank');
          } else {
            window.location.href = href;
          }
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        // Still redirect on error to maintain functionality
        if (href) {
          if (target === '_blank') {
            window.open(href, '_blank');
          } else {
            window.location.href = href;
          }
        }
      });
  }
}
